import { Page } from '@/shared/api/pagination';

export const getNextPageParamFn = <T extends Record<string, any>>(
  data: Page<T>,
) => {
  if (!data) return false;

  const nextPage =
    data?.page < Math.ceil(data.total / data.size) ? data?.page + 1 : undefined;

  return nextPage;
};